/**
 * `<FooterVersion />` para superadmin — Sprint 16 S16-10.
 *
 * Análogo al del portal pero fijo en módulo `administracion`. UI:
 * click copia versión completa al clipboard con feedback de 2s.
 */
import { useEffect, useState } from 'react';
import { getVersion, type VersionResponse } from '../../lib/api/version';

export function FooterVersion() {
  const [data, setData] = useState<VersionResponse | null>(null);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    let cancelado = false;
    getVersion()
      .then((r) => {
        if (!cancelado) setData(r);
      })
      .catch(() => {
        /* silencioso */
      });
    return () => {
      cancelado = true;
    };
  }, []);

  const versionString = data?.administracion ?? null;
  const textoMostrar = versionString ?? '—';

  async function handleClick() {
    if (!versionString) return;
    const completo = `Administración · ${versionString}`;
    try {
      await navigator.clipboard.writeText(completo);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      /* clipboard no disponible — silencioso */
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!versionString}
      className="text-xs text-text-muted hover:text-text-secondary transition-colors text-left font-mono"
      aria-label="Versión del módulo Administración"
      title={
        versionString
          ? 'Click para copiar al clipboard'
          : 'Versión no disponible'
      }
    >
      <span className="text-text-secondary font-sans">Administración</span>
      <span className="opacity-60 mx-1">·</span>
      <span>{textoMostrar}</span>
      {copiado && (
        <span className="ml-2 text-state-success font-sans">copiado</span>
      )}
    </button>
  );
}
